import './footer.scss'
import { CmsLink } from '../..'
import { cmsDataService, locationService } from '../..'
import { observer } from 'mobx-react'
import { FooterProps } from './models'
import React, { Suspense, useState, useEffect } from 'react'
import { FooterLinksSection } from '../..'
import FooterLogo from './subcomponents/FooterLogo'
import { FooterSocials } from './subcomponents/FooterSocials'

export const Footer: React.FC = observer(() => {
    const props = cmsDataService.get().footer

    const [locationName, setLocationName] = useState<string>(null)
    const [locationLinks, setLocationLinks] = useState<CmsLink[]>(null)

    useEffect(() => {
        locationService.locationName.observe_(({ oldValue, newValue }) => {
            const nameValue = newValue as string
            setLocationName(nameValue)
        })

        locationService.locationLinks.observe_(({ oldValue, newValue }) => {
            const linksValue = newValue as CmsLink[]
            setLocationLinks(linksValue)
        })
    })

    const footerLinksProps: FooterProps = {
        ...props,
        footerHeadingLocations: locationName,
        footerLocationSpecificLinks: locationLinks,
    }

    return (
        <footer>
            <div className="footer container-lg-padding">
                {footerLinksProps.footerLinks?.map((section, index) => (
                    <Suspense fallback={''} key={index}>
                        <FooterLinksSection {...section} />
                    </Suspense>
                ))}
            </div>
            <div className="address-and-socials-area">
                <FooterLogo
                    link={props.footerImageLink}
                    image={props.footerImage}
                    copyrightText={props.copyrightText ?? ''}
                />
                <FooterSocials {...props} />
            </div>
        </footer>
    )
})
